import React from "react";
import classNames from "classnames";
import { Map } from "immutable";

import EditorContentHeader from "./EditorContentHeader";
import EditableText from "./EditableText";
import StyleUtils from "../../utils/StyleUtils";
import PropertyMaps from "../../constants/PropertyMaps";
import { TEXT_FRAME_ID } from "../../constants/FrameConstants";
import { gatherProps } from "../../utils/Merge/MergeUtils.mjs";
import { TEXT_STYLE } from "../../constants/MergeConstants";
import AppConstants from "../../constants/AppConstants";

const { ELEMENT_TYPE_BUTTON } = AppConstants;

const {
  STYLE_PROPS_INLINE,
  TEXT_STYLE_PROPS,
  TEXT_NESTED_STYLES_INLINE_LINK,
  STYLE_PROPS_BUTTON_TEXT,
} = PropertyMaps;

const EditorFrameContent = ({
  designContext,
  element,
  layout,
  theme,
  buttonElement,
  onEdit,
  onEditComplete,
  onSelectionChange,
}) => {
  const _onEdit = (text, e) => {
    if (onEdit) {
      onEdit(text, e);
    }
  };

  const _onEditComplete = () => {
    if (onEditComplete) {
      onEditComplete();
    }
  };

  const content = element.get("content", Map());
  const isButtonType = element.get("type") === ELEMENT_TYPE_BUTTON;
  const text = isButtonType ? element.get("label", "") : content.get("text", "");

  let elemProps;
  if (isButtonType) {
    const initialElemProps = gatherProps(element, layout, STYLE_PROPS_BUTTON_TEXT, true, theme);
    elemProps = initialElemProps.get("text");
  } else {
    elemProps = gatherProps(element, layout, [
      TEXT_STYLE,
      ...TEXT_STYLE_PROPS,
      ...TEXT_NESTED_STYLES_INLINE_LINK,
    ]);
  }
  const baseStyle = elemProps.get("style");
  const linkStyle = elemProps.getIn(["styles", "link"], null);

  let textClasses;
  if (baseStyle) {
    const textStyleClass = StyleUtils.getStyleClass(baseStyle);
    textClasses = classNames(textStyleClass);
  }

  const initialTextStyle = StyleUtils.getStyle(STYLE_PROPS_INLINE, elemProps, theme);
  const textShadowStyle = StyleUtils.getShadowStyle(elemProps, theme, "text");
  const textStyle = { ...initialTextStyle, ...textShadowStyle };

  return (
    <div>
      <EditorContentHeader
        elementId={TEXT_FRAME_ID}
        layout={layout}
        isButton={buttonElement !== null}
        theme={theme}
        linkStyle={linkStyle}
        designContext={designContext}
      />
      <EditableText
        elementId={TEXT_FRAME_ID}
        style={textStyle}
        buttonElement={buttonElement}
        className={textClasses}
        text={text}
        onEditComplete={_onEditComplete}
        onEdit={_onEdit}
        onSelectionChange={onSelectionChange}
      />
    </div>
  );
};

export default EditorFrameContent;
